export const BLOG_NEW_ONBOARDING_FLOW = 'Blog:NewOnboardingFlow';